import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import Query from "../../components/Query";
import HOME_QUERY from "../../queries/home";

// import {Helmet} from "react-helmet-async";

import FAQ from "../../components/Faq";
import Anmelden from "../../components/Content/anmelden";
import Push from "../../components/Push";

// import { Link } from "react-router-dom";

const Home = () => {
  let year = new Date().getFullYear();

  return (
    <Query query={HOME_QUERY} id={null}>
      {({ data: { home } }) => {
        return (
          <>
            {/* <Helmet>
                <title>{home.data.attributes.seo.metaTitle}</title>
                <meta name="description" content={home.data.attributes.seo.metaDescription} />
                <meta name="keywords" content={home.data.attributes.seo.keywords} />
                <link rel="canonical" href={home.data.attributes.seo.canonicalURL} />
                <meta property="og:title" content={home.data.attributes.seo.metaTitle} />
                <meta property="og:description" content={home.data.attributes.seo.metaDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={home.data.attributes.seo.canonicalURL} />
                <meta property="og:image" content={process.env.REACT_APP_BACKEND_URL + home.data.attributes.seo.metaImage.data.attributes.url} />
            </Helmet> */}
            <header className="header">
              <Container fluid className="h-100 position-relative">
                <h1
                  className="header_title text-center text-lg-start"
                  data-aos="fade-right"
                  data-aos-offset="-100"
                >
                  <p>HIER BEGINNT</p>
                  <div></div>
                  <p>DEIN ABENTEUER!</p>
                </h1>
                <div
                  className="header_btnAbsolute"
                  data-aos="fade-up"
                  data-aos-offset="-100"
                >
                  <Anmelden btn="btn btn__fill btn__fill_primary"></Anmelden>
                </div>
              </Container>
            </header>
            <section
              className="layout layout__bg layout__bg_primary"
              id="intensivkurs"
            >
              <Container fluid>
                <Row>
                  <Col xs={12} xl={6} xxl={4} className="mb-5 mb-xl-0">
                    <Row className="flex-column justify-content-between h-100">
                      <Col className="mb-4 mb-xl-0">
                        <h2 data-aos="fade-up">
                          {home.data.attributes.Intensivecourse.title}
                        </h2>
                      </Col>
                      <Col xs={10} sm={10} md={8} lg={8} xl={7} xxl={9}>
                        <div
                          className="layout_iframe"
                          data-aos="fade-up"
                          dangerouslySetInnerHTML={{
                            __html:
                              '<iframe src="https://giphy.com/embed/fhAwk4DnqNgw8" width="100%" height="100%" style="position:absolute" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>',
                          }}
                        ></div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={12}
                    sm={11}
                    lg={8}
                    xl={6}
                    xxl={5}
                    className="offset-xxl-3"
                  >
                    <p
                      className="layout_text"
                      data-aos="fade-up"
                      dangerouslySetInnerHTML={{
                        __html:
                          home.data.attributes.Intensivecourse.description,
                      }}
                    ></p>
                  </Col>
                  <span className="layout_mt"></span>
                  <Col xs={12} xl={6} xxl={4} className="mb-5 mb-xl-0">
                    <Row className="flex-xl-column align-items-end justify-content-between h-100">
                      <Col xs={7} sm={5} lg={4} xl={12}>
                        <h2 data-aos="fade-up">
                          {home.data.attributes.Intensivecourse.title2}
                        </h2>
                      </Col>
                      <Col className="d-xl-flex align-items-end">
                        <p
                          className="text-end text-xl-start layout_text layout_text__big layout_text__light"
                          data-aos="fade-up"
                        >
                          {year}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={12}
                    sm={11}
                    lg={8}
                    xl={6}
                    xxl={5}
                    className="offset-xxl-3"
                  >
                    <ul className="layout_list">
                      {home.data.attributes.Intensivecourse.Schedule.map(
                        (item) => {
                          return (
                            <li
                              className="layout_list_item"
                              key={item.id}
                              data-aos="fade-up"
                            >
                              <Row className="w-100">
                                <Col
                                  xs={3}
                                  sm={2}
                                  xl={3}
                                  className="layout_list_marker d-flex align-items-center offset-sm-1 offset-xl-0"
                                >
                                  {item.day}
                                </Col>
                                <Col xs={4} xxl={3} className="text-start">
                                  {item.date}
                                </Col>
                                <Col className="offset-sm-1 offset-xl-0 offset-xxl-1">
                                  {item.time}
                                </Col>
                              </Row>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="layout layout__color_primary pb-0 pb-md-4">
              <Container fluid>
                <Row className="align-items-center">
                  <Col
                    xs={12}
                    md={6}
                    xl={6}
                    xxl={5}
                    className="text-end text-md-start text-xxl-end mt-4 mt-md-0 order-xl-1 offset-xl-1"
                  >
                    <img
                      data-aos="fade-up"
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        home.data.attributes.referal.image.data.attributes.url
                      }
                      alt={home.data.attributes.referal.title}
                      className="autoImg layout_image layout_image__round"
                    />
                  </Col>
                  <Col xs={12} md={10} xl={5} className="">
                    <h3
                      data-aos="fade-up"
                      className="layout_subtitle layout_title mb-4"
                    >
                      {home.data.attributes.referal.title}
                    </h3>
                    <p
                      data-aos="fade-up"
                      className="layout_text pe-md-2 pe-xl-3 pe-xxl-5 layout_mb"
                      dangerouslySetInnerHTML={{
                        __html: home.data.attributes.referal.descr,
                      }}
                    ></p>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="layout layout__color_primary">
              <Container fluid>
                <Row className="justify-content-between mb-5">
                  <Col md={6} lg={6} xxl={7} className="mb-5 mb-xl-0">
                    <h2 data-aos="fade-up">
                      {home.data.attributes.Services.title}
                    </h2>
                  </Col>
                  <Col xxl={4}>
                    <h4 className="h3 tt-normal" data-aos="fade-up">
                      {home.data.attributes.Services.description}
                    </h4>
                  </Col>
                  <Col xxl={1}></Col>
                </Row>
                <div className="layout_chapters">
                  {home.data.attributes.Services.Categories.map(
                    (item, index) => {
                      return (
                        <Link
                          to={`/fuehrerscheine/${item.name}`}
                          target="_top"
                          rel="noopener noreferrer"
                          key={item.id}
                          className="layout_chapters_item"
                          data-aos="fade-up"
                        >
                          <Row>
                            <Col
                              xs={
                                index ===
                                home.data.attributes.Services.Categories
                                  .length -
                                  1
                                  ? 12
                                  : 3
                              }
                              md={6}
                              xl={5}
                              xxl={6}
                              className={
                                index ===
                                home.data.attributes.Services.Categories
                                  .length -
                                  1
                                  ? "order-1 order-md-0 text-end text-md-start text-xxl-end mt-4 mt-md-0"
                                  : "text-xxl-end"
                              }
                            >
                              <h3 className="text-xxl-end layout_chapters_title layout_chapters_title_new">
                                {item.name}
                              </h3>
                            </Col>
                            <Col
                              xs={
                                index ===
                                home.data.attributes.Services.Categories
                                  .length -
                                  1
                                  ? 12
                                  : 9
                              }
                              md={6}
                              lg={5}
                              xl={4}
                              xxl={5}
                              className="offset-xl-1 layout_chapters_text"
                            >
                              <p className="layout_text mb-3 mb-xxl-0">
                                {item.description}
                              </p>
                              <button
                                className={
                                  index ===
                                  home.data.attributes.Services.Categories
                                    .length -
                                    1
                                    ? "d-none"
                                    : "btn btn__border btn__border_primary d-xxl-none"
                                }
                              >
                                Weiterlesen{" "}
                                <img
                                  alt="team"
                                  className="ms-2"
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACBUlEQVRIie2VT2sTURRHzx2TunMhghIpuJrUlTEJLgQVUcT4JxZbXFhdCHbsQgW/gAaLn0A3qSIKCpGK4CAogkI3oqmTbASTQRC6CBUkWASlWue5ic50oXkzw3TV3+pxePeeuW8eM7CaFYpo7bLKL4G9AChV55fs57b9NY7Y0NolrPPXsoMU96hU9GrjiY1R4HOAlOk4V+OI12jtetv6wvah1whjfo3somi6OO675MQAjfYcRXMBpNQjAnKIvPmchttJTgzguHUK2QxQ6JE0IofZlq3RbIe6bBEuyKbzwEwAZEgxzYXS2mTFU1M/QY0CHwN0J4vpapg24Y76Txz3G/mtM4g6DQz0aI6i2cVx68mJARqteYrZFnCCvx8iOUDenKXhfkhODOC031Mw0yC7e8RAKJEbekSz3f1faayvDwCZwmXA9oGsx1D3+5XFF0dMfHGnOQmUfaC6eDLWr0zv7/SvjB8dQWQ60GcJ8Q5SffKiX2n0iceHc4jcZfnDX9KRQtSJz5Y3YjALDPqd5A7Vx2d0W4Sf2LLSGDxYJoVXDPyYCNMmwlHP3wD2BMAcHse5/nQxObF17CJgBch3hBFu2Z9C9SHMOz53ZB/KeAakekShOMlNuxZWCroTTwxvQRm1gBQU16JK9cXKewhsCBCbzfkrUaX6YlgIrN+wxCkqFS+OeDUrlt8cKoJU3Wc7+AAAAABJRU5ErkJggg=="
                                ></img>
                              </button>
                            </Col>
                          </Row>
                        </Link>
                      );
                    }
                  )}
                </div>
              </Container>
            </section>
            <section className="layout layout__bg layout__bg_primary">
              <Container fluid>
                <h2
                  className="layout_title layout_title__light d-xl-none"
                  data-aos="fade-up"
                >
                  {home.data.attributes.Team.title}
                </h2>
                <Row className="align-items-center">
                  <Col
                    xs={12}
                    md={6}
                    xl={5}
                    xxl={6}
                    className="text-end text-md-start text-xxl-end mt-4 mt-md-0"
                  >
                    <img
                      data-aos="fade-up"
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        home.data.attributes.Team.thumbnail.data.attributes.url
                      }
                      alt={home.data.attributes.Team.title}
                      className="autoImg layout_image layout_image__round"
                    />
                  </Col>
                  <Col xs={12} md={10} xl={5} className="offset-xl-1">
                    <h2
                      data-aos="fade-up"
                      className="layout_title layout_title__light d-none d-xl-block layout_mb"
                    >
                      {home.data.attributes.Team.title}
                    </h2>
                    <h3
                      data-aos="fade-up"
                      className="layout_subtitle layout_subtitle__500 mb-4"
                    >
                      {home.data.attributes.Team.subtitle}
                    </h3>
                    <p
                      data-aos="fade-up"
                      className="layout_text pe-md-2 pe-xl-3 pe-xxl-5 layout_mb"
                    >
                      {home.data.attributes.Team.description}
                    </p>
                    <Link
                      to="/team"
                      target="_top"
                      className="btn btn__fill btn__fill_primary"
                      data-aos="fade-up"
                    >
                      ÜBER UNS
                    </Link>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="layout layout__color_primary">
              <Container fluid>
                <h2 className="" data-aos="fade-up">
                  FAQ
                </h2>
                <h3 className="" data-aos="fade-up">
                  {home.data.attributes.FAQ.title}
                </h3>
                <FAQ elements={home.data.attributes.FAQ.qa}></FAQ>
              </Container>
            </section>
            <Push></Push>
          </>
        );
      }}
    </Query>
  );
};

export default Home;
